import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slieces/authSlice";
import EmployeeReducer from "./slieces/employeeSlice";
import registrationReducer from "./slieces/registrationSlice";
import userReducer from "./slieces/userSlice";
import userSettingsReducer from "./slieces/userSettingsSlice";
import organizationSettingsReducer from "./slieces/organizationSettingsSlice";
import weekTemplateSlice from "./slieces/weekTemplateSlice";
import weekPlanSlice from "./slieces/weekPlanSlice";
import monthPlanSlice from "./slieces/monthPlanSlice";
import summaryEmployeeSlice from "./slieces/summaryEmplyeeSlice";
import workStatusAppSlice from "./slieces/workStatusAppSlice";
import subOrganisationReducer from "./slieces/subOrganisationSlice";
import paidOvertimeReducer from "./slieces/paidOvertimeSlice";
import licenseReducer from "./slieces/licenseSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    employees: EmployeeReducer,
    registration: registrationReducer,
    userData: userReducer,
    userSettings: userSettingsReducer,
    organizationSettings: organizationSettingsReducer,
    weekTemplate: weekTemplateSlice,
    weekPlan:weekPlanSlice,
    monthPlan: monthPlanSlice,
    summaryEmployee:summaryEmployeeSlice,
    workStatusApp:workStatusAppSlice,
    subOrganisationData: subOrganisationReducer,
    paidOvertime: paidOvertimeReducer,
    license: licenseReducer

  },
});